<template>
  <div class="ajuda">
    <div class="container">
      <h1 class="display-1 my-3">Tabela de atividades: CNAE / Item da Lista de Serviços</h1>
      <v-divider></v-divider>
      <p class="subtitle-2 grey--text my-3">
        Consulta à Classificação Nacional de Atividades Econômicas – CNAE , relacionada à alíquota do Imposto Sobre
        Serviços de Qualquer Natureza e ao item da Lista de Serviços.
      </p>
      <v-btn class="my-2" small color="primary" outlined type="submit" @click="baixarTabelaAtividades" v-if="tipoConsultaAtividade === 'PDF'">
        <v-icon small left>exit_to_app</v-icon>
        <span>Consultar PDF</span>
      </v-btn>
      <v-btn class="my-2" small color="primary" outlined :href="urlAtividade" target="_blank" v-else>
        <v-icon small left>exit_to_app</v-icon>
        <span>Consultar URL</span>
      </v-btn>
      <v-divider></v-divider>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tipoConsultaAtividade: {
      type: String,
    },
    urlAtividade: {
      type: String,
    },
  },
  methods: {
    baixarTabelaAtividades() {

      if (this.tipoConsultaAtividade === 'PDF') {
        this.$httpNF(
            `notafiscal/tabelaatividade`,
            {
              method: "GET",
              responseType: "blob",
            }
        ).then((res) => {
          if (res.data.size !== 0) {
            this.loginSuccess = true;
            let blob = new Blob([res.data], {
              type: "application/pdf",
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "tabela-atividades";
            link.click();
          }
          // let blob = new Blob([res.data], {
          //   type: "application/pdf"
          // });
          // let url = window.URL.createObjectURL(blob);
          // window.open(url);
        }).catch((error) => console.log(error));
      } else {
        window.location.href = this.urlAtividade;
      }
    }
  },

};
</script>
